{
    "warning": "AVERTIZARE!",
    "message": "Nu introdu sau lipi cod pe care nu îl înțelegi.\nDacă folosești această consolă, le poți permite atacatorilor să îți fure identitatea și informațiile printr-un atac denumit Self-XSS."
}
